import { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import Attention from '../icons/Attention';

interface VerificationWarningProps {
    iconClassName?: string;
    className?: string;
}

export default function VerificationWarning({ iconClassName = 'w-4 h-4', className = '' }: VerificationWarningProps) {
    const [tooltipPos, setTooltipPos] = useState<{ top: number; left: number } | null>(null);
    const iconRef = useRef<HTMLSpanElement>(null);

    const handleMouseEnter = () => {
        if (iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            setTooltipPos({
                top: rect.top - 4,
                left: rect.left + rect.width / 2,
            });
        }
    };

    return (
        <span
            ref={iconRef}
            className={`relative flex items-center flex-shrink-0 ${className}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={() => setTooltipPos(null)}
            onPointerDown={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
        >
            <Attention className={`${iconClassName} text-amber-500`} />
            {tooltipPos && ReactDOM.createPortal(
                <div
                    className="fixed -translate-x-1/2 -translate-y-full px-2 py-1.5 bg-white rounded shadow-lg border border-gray-200 whitespace-nowrap z-[9999] font-normal pointer-events-none"
                    style={{ top: tooltipPos.top, left: tooltipPos.left }}
                >
                    <div className="text-xs font-medium text-amber-600">Manual verification required</div>
                    <div className="text-xs text-gray-500">Complex rules apply. Verify with official Cornell resources.</div>
                </div>,
                document.body
            )}
        </span>
    );
}
